<template>
    <div
        class="modal fade"
        id="cheatSheetModal"
        tabindex="-1"
        aria-hidden="true"
        ref="modal"
    >
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content bg-dark text-light rounded-3 shadow-lg">
                <div class="modal-header">
                    <h4 class="modal-title">Cheat Sheet {{ theme }}</h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                    ></button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Combat Options</p>
                                </div>
                                <div class="card-body">
                                    <ul>
                                        <li>
                                            <strong>Move:</strong> Move up to
                                            your <em>Move Distance</em> (run,
                                            climb, etc.).
                                        </li>
                                        <li>
                                            <strong>Attack:</strong> Make a
                                            <em>Strike</em> or use an ability
                                            that costs an Attack Action.
                                        </li>
                                        <li>
                                            <strong>Interact:</strong> Any other
                                            action (use item, heal, escape,
                                            etc.). If you skip your Attack
                                            Action, you may take
                                            <strong>2 Interact Actions</strong>
                                            instead.
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Advantage / Disadvantage</p>
                                </div>
                                <div class="card-body">
                                    <p><strong>Advantage</strong></p>
                                    <ul>
                                        <li>
                                            <strong>Minor:</strong> +1
                                            <em>Skill Die</em> to your Dice
                                            Pool.
                                        </li>
                                        <li>
                                            <strong>Major:</strong> +1
                                            <em>Talent Die</em> to your Dice
                                            Pool.
                                        </li>
                                    </ul>
                                    <p>
                                        <em
                                            >Granted at the Director’s
                                            discretion for clever or exceptional
                                            actions.</em
                                        >
                                    </p>

                                    <p><strong>Disadvantage</strong></p>
                                    <ul>
                                        <li>
                                            <strong>Minor:</strong> –1
                                            <em>Skill Die</em> (min 1).
                                        </li>
                                        <li>
                                            <strong>Major:</strong> –1
                                            <em>Talent Die</em>; if none, –2
                                            <em>Skill Dice</em> (min 1).
                                        </li>
                                    </ul>
                                    <p>
                                        <em
                                            >Applied when conditions hinder the
                                            character or raise difficulty.</em
                                        >
                                    </p>
                                </div>
                            </div>

                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Critical Hit</p>
                                </div>
                                <div class="card-body">
                                    <p>
                                        Score a <strong>Critical Hit</strong> by
                                        exceeding the enemy’s
                                        <strong>CR</strong> by
                                        <strong>2+ successes</strong> on a Skill
                                        Check.
                                    </p>
                                    <ul>
                                        <li>
                                            <strong>Effect:</strong>
                                            <strong>Double damage</strong> +
                                            apply the relevant
                                            <strong>Core Skill</strong> effect:
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>
                                            <strong>Grit:</strong> Target is
                                            <em>Prone</em>.
                                        </li>
                                        <li>
                                            <strong>Wit:</strong> Make
                                            <em>one extra Strike</em> (cannot
                                            crit).
                                        </li>
                                        <li>
                                            <strong>Smarts:</strong> Inflict
                                            <em>Bleed (2)</em>.
                                        </li>
                                        <li>
                                            <strong>Heart:</strong> You are
                                            <em>Steeled</em> until your next
                                            turn.
                                        </li>
                                        <li>
                                            <strong>Luck:</strong> Roll Luck
                                            Pool; +1 damage per
                                            <em>Luck</em> symbol.
                                        </li>
                                        <li>
                                            <strong>Strange:</strong> Target
                                            becomes <em>Terrified</em>.
                                        </li>
                                    </ul>
                                    <p><strong>Full House</strong></p>
                                    <p>
                                        If rolling <strong>3+ dice</strong> and
                                        <strong>all succeed</strong>:
                                        <strong>Triple damage</strong> + Core
                                        Skill effect.
                                    </p>
                                </div>
                            </div>

                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Luck and the Bank</p>
                                </div>
                                <div class="card-body">
                                    <p>
                                        Rolling a Luck symbol grants a Luck
                                        Point, stored in your Luck Bank. A Luck
                                        Point can be spent to add one Skill Die
                                        to a Skill Check. You may use it
                                        immediately or save it, but only one
                                        Luck Point can be banked at a
                                        time—additional points are lost if the
                                        bank is full.
                                    </p>
                                    <p>
                                        Rolling two Luck symbols lets you either
                                        treat them as one success or tick back
                                        the Doom Clock by 1 minute.
                                    </p>
                                </div>
                            </div>

                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Armour</p>
                                </div>
                                <div class="card-body">
                                    <p>
                                        When hit, roll
                                        <strong
                                            >1 Skill Die per Armour Slot</strong
                                        >:
                                    </p>
                                    <ul>
                                        <li>
                                            <strong>Luck:</strong> -1 damage,
                                            armour unharmed
                                        </li>
                                        <li>
                                            <strong>Strange:</strong> -1 damage,
                                            armour takes 1 wound
                                        </li>
                                        <li>
                                            <strong>Other:</strong> Full damage
                                            taken
                                        </li>
                                    </ul>
                                    <p>
                                        When all Slots of an armour piece are
                                        destroyed, its effects no longer apply.
                                    </p>
                                    <p>
                                        Roll separately for each Slot.
                                        Multi-slot armour rolls once per Slot
                                        and is only destroyed when
                                        <strong>all Slots</strong> are at 0 HP.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Grit</p>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <img
                                                :src="
                                                    require(`@/../public/img/grit${theme}.png`)
                                                "
                                                alt="grit icon"
                                                class="img-fluid"
                                            />
                                        </div>
                                        <div class="col-sm-9">
                                            <p>
                                                Lifting heavy objects, punching,
                                                running, and climbing. Anything
                                                requiring brute force,
                                                athleticism, or physical
                                                fortitude.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Wit</p>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <img
                                                :src="
                                                    require(`@/../public/img/wit${theme}.png`)
                                                "
                                                alt="wit icon"
                                                class="img-fluid"
                                            />
                                        </div>
                                        <div class="col-sm-9">
                                            <p>
                                                Picking locks, sneaking and
                                                Stealth, sleight of hand,
                                                throwing objects, firearm
                                                proficiency. This is a measure
                                                of mental and physical agility,
                                                usually used for actions of a
                                                more dexterous nature.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Smarts</p>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <img
                                                :src="
                                                    require(`@/../public/img/smarts${theme}.png`)
                                                "
                                                alt="smarts icon"
                                                class="img-fluid"
                                            />
                                        </div>
                                        <div class="col-sm-9">
                                            <p>
                                                Obtaining knowledge from your
                                                surroundings, improvising
                                                weapons and tools, using
                                                computers and tech. Actions that
                                                require you to use your brain
                                                and deductive thought rather
                                                than physicality.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Heart</p>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <img
                                                :src="
                                                    require(`@/../public/img/heart${theme}.png`)
                                                "
                                                alt="heart icon"
                                                class="img-fluid"
                                            />
                                        </div>
                                        <div class="col-sm-9">
                                            <p>
                                                Persuasion, deception,
                                                performance. Any action that
                                                requires pure charisma, whether
                                                that be to lie through your
                                                teeth, charm somebody to help
                                                you or intimidate them to leave
                                                you alone.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Luck</p>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <img
                                                :src="
                                                    require(`@/../public/img/luck${theme}.png`)
                                                "
                                                alt="luck icon"
                                                class="img-fluid"
                                            />
                                        </div>
                                        <div class="col-sm-9">
                                            <p>
                                                Determines how naturally lucky
                                                you are. Adds random boosts to
                                                all actions, random chance is
                                                always on your side. A gamble on
                                                all fronts but can reap great
                                                rewards.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card bg-dark text-light mb-3">
                                <div class="card-header">
                                    <p class="mb-0">Strange</p>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <img
                                                :src="
                                                    require(`@/../public/img/strange${theme}.png`)
                                                "
                                                alt="strange icon"
                                                class="img-fluid"
                                            />
                                        </div>
                                        <div class="col-sm-9">
                                            <p>
                                                Use of magic, psychic powers and
                                                other unnatural abilities. It
                                                also determines how resistant to
                                                things that may cause others to
                                                run away in fear. Dangerous but
                                                very powerful.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-secondary" data-bs-dismiss="modal">
                        <font-awesome-icon icon="multiply" class="me-1" /> Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CheatSheetModal",
    props: {
        theme: { type: Number, required: true },
    },
};
</script>

<style scoped>
/* Make modal-xxl sized (≈95% of viewport) */
.modal-dialog {
    max-width: 95vw;
    max-height: 95vh;
    width: 95vw;
    height: 95vh;
}

/* Ensure the modal content fills dialog and flexes properly */
.modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 0.75rem;
    overflow: hidden;
}

/* Keep header and footer fixed, body scrollable */
.modal-header,
.modal-footer {
    flex-shrink: 0;
}

.modal-body {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 1.5rem;
}

/* Optional: dark theme polish */
.modal-content.bg-dark {
    background-color: #1e1e1e !important;
}
</style>

